(function () {
  if (customElements.get('video-card')) return;

  function fmt(t) {
    t = Math.floor(t || 0);
    var m = Math.floor(t / 60);
    var s = t % 60;
    return (m < 10 ? '0' : '') + m + ':' + (s < 10 ? '0' : '') + s;
  }

  class VideoCard extends HTMLElement {
    connectedCallback() {
      this.video = this.querySelector('video');
      this.progress = this.querySelector('[data-vprogress]');
      this.rec = this.querySelector('[data-vrec]');
      this.autoplay = this.getAttribute('data-autoplay') !== 'false';
      this.reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      if (!this.video) return;

      // Ensure inline + muted so autoplay is allowed on mobile
      this.video.muted = true;
      this.video.setAttribute('muted', '');
      this.video.playsInline = true;
      this.video.setAttribute('playsinline', '');

      this.video.addEventListener('timeupdate', this.onTime.bind(this));

      if (this.autoplay && !this.reduce) {
        this.observe();
      }
    }

    onTime() {
      if (this.progress && this.video.duration) {
        this.progress.style.width = (this.video.currentTime / this.video.duration) * 100 + '%';
      }
      if (this.rec) {
        this.rec.textContent = fmt(this.video.currentTime);
      }
    }

    observe() {
      var self = this;
      if (!('IntersectionObserver' in window)) {
        this.tryPlay();
        return;
      }
      this.io = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (e) {
            if (e.isIntersecting) self.tryPlay();
            else self.video.pause();
          });
        },
        { threshold: 0.25 }
      );
      this.io.observe(this);
    }

    tryPlay() {
      var p = this.video.play();
      if (p && p.catch) p.catch(function () {});
    }

    disconnectedCallback() {
      if (this.io) this.io.disconnect();
    }
  }

  customElements.define('video-card', VideoCard);
})();
